"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLogin = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _react = require("react");

var _api = require("../api");

var _useRequest = require("./useRequest");

var _useProvisoApi = require("./useProvisoApi");

var _useContextProvider = require("./useContextProvider");

var _actions = require("../context/actions");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var useLogin = function useLogin() {
  var dispatch = (0, _useContextProvider.useContextSelector)(function (ctx) {
    return ctx.dispatch;
  });
  var api = (0, _useProvisoApi.useProvisoApi)();
  var state = (0, _useRequest.useRequest)();
  var request = state.request,
      data = state.data;
  (0, _react.useEffect)(function () {
    if (data && data.accounts) {
      dispatch((0, _actions.setAccounts)(data.accounts));
    }
  }, [data, dispatch]);
  var req = (0, _react.useMemo)(function () {
    if (!api) {
      return null;
    }

    return /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(credentials) {
        var res;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return request((0, _api.login)(api)(credentials));

              case 2:
                res = _context.sent;

                if (!res.error) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", res);

              case 5:
                return _context.abrupt("return", res);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();
  }, [api, request]);
  return _objectSpread(_objectSpread({}, state), {}, {
    request: req
  });
};

exports.useLogin = useLogin;